var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 72,
    viewBox: "0 0 242 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.913 51.2016L201.872 23.3926H206.863L212.964 46.7521L219.341 23.3926H224.333L230.711 46.7521L236.811 23.3926H241.802L233.761 51.2016H227.938L221.837 29.1212L215.737 51.2016H209.913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.747 52.0369C178.596 52.0369 174.159 45.3628 174.159 37.2982C174.159 29.2335 178.596 22.5594 187.747 22.5594C196.898 22.5594 201.334 29.2335 201.334 37.2982C201.334 45.3628 196.898 52.0369 187.747 52.0369ZM179.151 37.2982C179.151 45.3628 183.033 48.6998 187.747 48.6998C192.461 48.6998 196.343 45.3628 196.343 37.2982C196.343 29.2335 192.461 25.8965 187.747 25.8965C183.033 25.8965 179.151 29.2335 179.151 37.2982Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.817 51.2026H166.103V15.0509H170.817V51.2026Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.206 51.2026H157.492V15.0509H162.206V51.2026Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.712 52.0369C132.561 52.0369 128.125 45.3628 128.125 37.2982C128.125 29.2335 132.561 22.5594 141.435 22.5594C150.585 22.5594 154.19 29.5116 154.19 36.1858V38.4105H133.116C133.449 45.6965 137.22 48.6998 141.712 48.6998C145.317 48.6998 148.367 46.7532 149.199 42.86H153.913C152.804 48.1437 148.644 52.0369 141.712 52.0369ZM141.435 25.8965C137.164 25.8965 133.837 28.6217 133.227 35.0734H149.199C149.199 28.6774 145.65 25.8965 141.435 25.8965Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0844 51.2026V15.0509H94.2941L105.941 45.6408L117.587 15.0509H124.797V51.2026H120.083V20.0565L108.159 51.2026H103.722L91.7985 20.0565V51.2026H87.0844Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 69C54.2254 69 69 54.2254 69 36C69 17.7746 54.2254 3 36 3C17.7746 3 3 17.7746 3 36C3 54.2254 17.7746 69 36 69ZM36 72C55.8822 72 72 55.8822 72 36C72 16.1177 55.8822 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8822 16.1177 72 36 72Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9089 57.5466C52.8082 57.5466 62.4544 47.9004 62.4544 36.0011C62.4544 24.1019 52.8082 14.4557 40.9089 14.4557C29.0097 14.4557 19.3635 24.1019 19.3635 36.0011C19.3635 47.9004 29.0097 57.5466 40.9089 57.5466ZM40.9089 60.5466C54.465 60.5466 65.4544 49.5572 65.4544 36.0011C65.4544 22.4451 54.465 11.4557 40.9089 11.4557C27.3529 11.4557 16.3635 22.4451 16.3635 36.0011C16.3635 49.5572 27.3529 60.5466 40.9089 60.5466Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 46.0909C41.5731 46.0909 46.0909 41.573 46.0909 36C46.0909 30.4269 41.5731 25.9091 36 25.9091C30.427 25.9091 25.9091 30.4269 25.9091 36C25.9091 41.573 30.427 46.0909 36 46.0909ZM36 49.0909C43.2299 49.0909 49.0909 43.2299 49.0909 36C49.0909 28.7701 43.2299 22.9091 36 22.9091C28.7701 22.9091 22.9091 28.7701 22.9091 36C22.9091 43.2299 28.7701 49.0909 36 49.0909Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mellow.8d1b9482aa07a57851abd6bb3b25537c.svg";